import React, {useContext} from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  InputGroup,
  InputGroupAddon,
  Row,
  UncontrolledTooltip,
  CustomInput,
  Input,
  UncontrolledDropdown, DropdownToggle, DropdownMenu
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import * as Icon from "react-feather";
import ScanbuyTable, {TableColumn} from "../../tables/ScanbuyTable";
import TableActionsDropdown from "../../tables/TableActionsDropdown";
import GroupSelect from "../../elements/groups/GroupSelect";
import {useRouterStore} from "mobx-state-router";
import DeleteRuleSetState from "../../configs/rulesets/delete/DeleteRuleSetState";
import DeleteRuleSetView from "../../configs/rulesets/delete/DeleteRuleSetView";
import DeleteUtmState from "../delete/DeleteUtmState";
import DeleteUtmView from "../delete/DeleteUtmView";
import GenericModal from "../../elements/modal/GenericModal";
import dayjs from "dayjs";
import {createdByColumn, updatedByColumn} from "../../tables/TableColumns";
import OptionalColumnsDropdown from "../../elements/dropdown/OptionalColumnsDropdown";
import {getSnapshot} from "mobx-state-tree";
import AdvancedConfFilterSelect from "../../elements/filters/AdvancedConfFilterSelect";
import CodeOwnerFilterSelect from "../../elements/filters/CodeOwnerFilterSelect";
import {buildDimensionFilters} from "../../../utils/buildDimensionFilters";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDoubleDown, faAngleDoubleUp, faSlidersH} from "@fortawesome/free-solid-svg-icons";

import TagSelect from "../../elements/tags/TagSelect";
import {ADVANCED_SETTINGS_MANAGE_SET, formConstants} from "../../../utils/constants"
import {StateContext} from "../../../App";
import TagFilterSelect from "../../elements/filters/TagFilterSelect";
import GroupFilterSelect from "../../elements/filters/GroupFilterSelect";
import {requiredRolesCheck} from "../../../utils/requiredRolesCheck";
import ResetButton from "../../ResetButton";
import {buildColumnsWithOptionalSupport} from "../../../utils/optionalColumnsHelper";


export const buildUtmsColumns = (routerStore,utmsListViewState) => {

  const {rootStore} = routerStore.options;
  const visible = new Set(utmsListViewState.optionalColumns);

  const c1 = TableColumn.create({name: 'Utm', property: 'utm', sortable: true, sortField: 'name'});
  c1.setSelector((row) =>{
    return(
      <>
      <span id={`tooltip-${row.uuid}`}>{row.label}</span>
      <UncontrolledTooltip target={`tooltip-${row.uuid}`} placement="top">{row.label}</UncontrolledTooltip>
      </>
    )})
  const c2 = TableColumn.create({name: 'Default', property: 'isDefault'});
  // c2.setSelector((row) => row.isDefault.toString());

  const actionColl = TableColumn.create({
    name: 'Actions', property: 'actions', button: true, allowOverflow: true, ignoreRowClick: true
  });
  const c3 = TableColumn.create({
    name: 'Tag(s)', property: 'tags', hide: 'sm'
  });
  c3.setSelector((row) => {
    return row.tags;
  });
  c3.setCell((row) => {
    const tags = row?.tags?.flatMap((t) => {
      return {uuid: t?.uuid, name: t?.name, color: t?.uiStyleConfigs?.color || 'info'}
    });
    return (<div>
      {tags.map((tag, index) => (<Badge
        key={index}
        color="info"
        className="badge-pill mr-1 mb-1"
      >
        {tag.name}
      </Badge>))}
    </div>)
  })
  const c4 = TableColumn.create({
    name: 'Create Date', property: 'created', width: '15%', hide: 'sm',sortable: true, sortField: 'createdAt',
  });
  c4.setSelector((row) => {
    // console.log(row)
    const {createdAt} = row || {};
    const formattedCreateDate = dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedCreateDate;
  });

  const c5 = TableColumn.create({
    name: 'Last Modified', property: 'updated', width: '15%', hide: 'sm', sortable: true, sortField: 'updatedAt',
  });
  c5.setSelector((row) => {
    // console.log(row)
    const { updatedAt } = row || {};
    const formattedUpdateDate = dayjs(updatedAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedUpdateDate;
  });

  const createdBy = createdByColumn();
  const updatedBy = updatedByColumn();


  actionColl.setCell((row) => (
    <TableActionsDropdown actionsList={[
      <DropdownItem id="action-btn-view" key={'/configs/utms/view/' + row.uuid} onClick={() => {
        routerStore.goTo('editUtm', {
          params: { uuid: row.uuid },
          queryParams: {isEditable: 'false'}
        });
      }}><Icon.FileText/>&nbsp;View</DropdownItem>,
      ...(row.isEditable ? [
      <DropdownItem id="action-btn-edit" key={'/configs/utms/edit/' + row.uuid} onClick={() => {
        routerStore.goTo('editUtm', {
          params: { uuid: row.uuid },
        });
      }}><Icon.Edit/>&nbsp;Edit</DropdownItem>]: []),
      ...(row.isEditable ? [
      <DropdownItem id="action-btn-clone" key={'new'} onClick={() => {
        // const snapshot = getSnapshot(row);
        rootStore.rootUiStore.addCloneToCache(`clone-utm:${row.uuid}`,row);
        routerStore.goTo('createUtm',{
          queryParams: {q: row.uuid}
        })
      }}><Icon.Copy/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.clone.defaultMessage"/>
      </DropdownItem>]: []),
      ...(row.isEditable ? [
      <DropdownItem id="action-btn-delete" key={row.uuid} value={"Delete " + row.uuid} className="align-text-bottom"
                    onClick={() => {

                      const userRoles = rootStore?.userRoles
                      if(!requiredRolesCheck(ADVANCED_SETTINGS_MANAGE_SET, userRoles)) return

                      const componentStore = DeleteUtmState.create(
                        {
                          utmName: row.name,
                          title: `Delete ${row.name ? row.name : ""}`,
                          uuid: row.uuid
                        });
                      rootStore.rootUiStore.attachPageState('deleteUtmState', componentStore)

                      componentStore.setToggleListener(utmsListViewState.modalStore.toggle)
                      componentStore.setRefreshListener(utmsListViewState.refresh)
                      utmsListViewState.handleRowClick(row, componentStore, DeleteUtmView);
                    }}> <Icon.Delete/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.delete.defaultMessage"/>
      </DropdownItem>]: [])

    ]}/>
  ))
  const allColumns = [

    c1,
    // c2,
    c3,
    createdBy,
    updatedBy,
    c4,
    c5,
    actionColl,
  ];

  return buildColumnsWithOptionalSupport(allColumns, utmsListViewState, rootStore);
}

const UtmsListView = observer(({utmsListViewState}) => {
  const routerStore = useRouterStore();
  const intl = useIntl();
  const stateContext = useContext(StateContext);

  const optionalColumns = stateContext?.appConfigs?.configs?.optional_columns || ['updatedBy'];

  // Get column name mapping from state
  const columnNameMapping = utmsListViewState.columnNameMapping || {};
    console.log("utmStore", utmsListViewState.columns);
    console.log("utmStore", utmsListViewState);
    //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
    // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
    utmsListViewState.setOnSelectChanges()
  //TODO: PATTERN VIOLATION - Multiple filter setters called on every render (lines 203-209)
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
    utmsListViewState?.advFilterSelectState?.setEmails(utmsListViewState.listModel?.filters?.users);
    utmsListViewState?.tagFilterSelectState?.setTags(utmsListViewState.listModel?.filters?.tags);
    utmsListViewState?.filterGroup && utmsListViewState?.groupFilterSelectState?.setGroups(utmsListViewState.listModel?.filters?.groups);
    utmsListViewState?.dimensionSelectViewState?.setFilteredDimensions(utmsListViewState?.listModel?.filters.dimensions);

    utmsListViewState?.loadFiltersFromSessionStorage()

    const customStyles = {
      headRow: {
        style: {
          border: 'none',
        },
      },
      headCells: {
        style: {
          color: '#202124',
          fontSize: '14px',
        },
      },
      rows: {
        highlightOnHoverStyle: {
          backgroundColor: 'rgb(230, 244, 244)',
          borderBottomColor: '#FFFFFF',
          outline: '1px solid #FFFFFF',
        },
      },
      pagination: {
        style: {
          border: 'none',
        },
      },
    }

    return (
      <>
        <Card>
          <CardBody>
            <Row>
              <Col className="d-flex justify-content-end list-view-actions-container">
                {utmsListViewState.isFilterVisible ? (
                  <Button
                    id="codelist-dropdown-open"
                    color="primary"
                    onClick={() => utmsListViewState.toggleFilterVisible()}
                  >
                    <FontAwesomeIcon icon={faAngleDoubleUp} />
                  </Button>
                ) : (
                  <Button
                    id="codelist-dropdown-closed"
                    color="primary"
                    onClick={() => utmsListViewState.toggleFilterVisible()}
                  >
                    <FontAwesomeIcon icon={faAngleDoubleDown} />
                  </Button>
                )}

                <OptionalColumnsDropdown
                  listViewState={utmsListViewState}
                  buildColumnsFunction={buildUtmsColumns}
                  idPrefix="utm-col"
                />
              </Col>
            </Row>
            {utmsListViewState.isFilterVisible && <>
              <Row>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "filterByGroups.defaultMessage"})}
                    </InputGroupAddon>
                    {/*<GroupSelect groupSelectStore={utmsListViewState?.groupSelectStore} multi={true}/>*/}
                    <GroupFilterSelect groupFilterSelectState={utmsListViewState.groupFilterSelectState}/>
                  </InputGroup>
                </Col>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "listCodes.filter.filterName.defaultMessage"})}
                    </InputGroupAddon>
                    <AdvancedConfFilterSelect advFilterSelectState={utmsListViewState.advFilterSelectState}/>
                  </InputGroup>
                </Col>
              </Row>
              <Row className="list-view-row-align-end">
                <Col sm={10}>
                  <Row>
                    {utmsListViewState?.dimensionSelectViewState?.dimensionsEnabled && utmsListViewState?.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => buildDimensionFilters(dimensionSelectStore, 6))}
                  </Row>
                </Col>
                <ResetButton viewState={utmsListViewState}/>
              </Row>
              <Row>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "listCodes.searchInput.defaultMessage"})}
                    </InputGroupAddon>
                    <Input
                      type="text"
                      name="searchInput"
                      placeholder="Search"
                      onChange={utmsListViewState.onSearchChange}
                      value={utmsListViewState.searchTxt}
                    />
                  </InputGroup>
                </Col>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({ id: "listCodes.filterBytags.defaultMessage"})}
                    </InputGroupAddon>
                    {/*<TagSelect tagSelectStore={utmsListViewState?.tagSelectStore}/>*/}
                    <TagFilterSelect tagFilterSelectState={utmsListViewState.tagFilterSelectState}/>
                  </InputGroup>
                </Col>
                <Col sm = {1}>
                  <CustomInput
                    type="switch"
                    id="isFilterTypeOR"
                    name="isFilterTypeOR"
                    label={formConstants.Mode.OR}
                    checked={utmsListViewState.isFilterTypeOR}
                    onChange={() => utmsListViewState.selectFilterMethod()}
                  />
                </Col>
                <Col  sm={1} className="justify-content-end text-right" >
                  <Button id="create-utm-btn" color="primary" onClick={() => {
                    routerStore.goTo('createUtm', {});
                  }}>
                    <FormattedMessage id="qrDesign.manageList.create.defaultMessage"/>
                  </Button>
                </Col>
              </Row>
            </>}
            <Row>
              <Col>
                {utmsListViewState.listModel.store.list.length ?
                  <ScanbuyTable
                    key={utmsListViewState?.columns.length}
                    columns={utmsListViewState.columns}
                    customStyles={customStyles}
                    store={utmsListViewState.listModel}
                    state={utmsListViewState}
                  />
                  :
                  <ScanbuyTable
                    key={utmsListViewState?.columns.length}
                    columns={utmsListViewState.columns}
                    customStyles={customStyles}
                    store={utmsListViewState.listModel}
                    state={utmsListViewState}s
                  />
                }
              </Col>
            </Row>
          </CardBody>
        </Card>
        <GenericModal
          modalStore={utmsListViewState.modalStore}
          componentStore={utmsListViewState.modalComponentStore}
          EmbedComponent={utmsListViewState.modalComponent}
        />
      </>
    )
  }
)

export default UtmsListView
